/* Shared add-to-cart for the 2026 homepage modules.
   ---------------------------------------------------------------------------
   This is NOT a second cart implementation. It POSTs to the theme's own
   cart/add endpoint and then hands straight off to the wiring that already
   exists, so the drawer, the count bubble, the free-gift logic and
   order-protection all behave exactly as they do on a PDP:

     • if <top-drawer> is on the page, open() it — its close() calls
       fetchCart(), which re-renders #cart-drawer and updates cart-counter;
     • otherwise dispatch 'theme:product:add', which mini-cart.js:139 binds
       directly to fetchCart().

   Same two-branch handoff as assets/rc-continuum.js and the abz bundle
   sections. Nothing here touches CartJS, and nothing navigates to /cart/add —
   a full navigation would skip the drawer entirely.

   MARKETS: the endpoint is built from window.Shopify.routes.root, which
   carries the market subfolder (/en-uk/, /en-ca/, …). A literal '/cart/add.js'
   would post into the primary market and add at AU pricing.

   Delegated from document, so buttons rendered after load — a section
   re-render in the customizer, a lazily-built rail — are picked up without
   rebinding. */

(function () {
  'use strict';

  var PENDING = 'is-adding';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function handoff() {
    var upsell = document.querySelector('top-drawer');
    if (upsell && typeof upsell.open === 'function') {
      upsell.open();
    } else {
      document.dispatchEvent(new CustomEvent('theme:product:add'));
    }
  }

  /* The button reports its own failure rather than failing silently: a
     shopper who taps Add and sees nothing happen assumes it worked. Restores
     after 2.4s so the tile is not left permanently in an error state. */
  function fail(btn, message) {
    var label = btn.querySelector('[data-rb-add-label]');
    if (!label) return;
    /* innerHTML, not textContent, on the STASH and the RESTORE. The label can
       contain markup now — a struck-through was-price and a coloured
       now-price from snippets/rb-price-label.liquid — and a textContent
       round-trip flattens it to "· $178 $169" in one colour, permanently,
       with nothing to indicate anything was lost. The MESSAGE is still set as
       textContent, so a string from a server response can never be markup. */
    if (!btn.rbLabelHtml) btn.rbLabelHtml = label.innerHTML;
    label.textContent = message;
    btn.setAttribute('data-rb-add-failed', '');
    window.setTimeout(function () {
      label.innerHTML = btn.rbLabelHtml;
      btn.removeAttribute('data-rb-add-failed');
    }, 2400);
  }

  function add(btn) {
    var variantId = btn.getAttribute('data-rb-add');
    if (!variantId || btn.classList.contains(PENDING)) return;

    var quantity = parseInt(btn.getAttribute('data-rb-add-qty'), 10);
    if (!quantity || quantity < 1) quantity = 1;

    btn.classList.add(PENDING);
    btn.setAttribute('aria-disabled', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          /* cart/add.js answers 422 with a JSON body describing why — sold
             out, or a quantity the inventory policy will not allow. That
             description is the useful message, so it is read before the
             status is thrown on. */
          if (!r.ok) {
            var err = new Error(data && data.description ? data.description : 'cart/add failed');
            err.handled = !!(data && data.description);
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        handoff();
      })
      .catch(function (e) {
        console.error('[rb-add-to-cart]', e);
        fail(btn, e.handled ? 'Unavailable' : 'Try again');
      })
      .finally(function () {
        btn.classList.remove(PENDING);
        btn.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-rb-add]');
    if (!btn) return;
    event.preventDefault();
    add(btn);
  });

  /* Buttons are <button type="button">, so Enter and Space already activate
     them natively and no key handler is needed here. */
})();
